export default "__VITE_PUBLIC_ASSET__8988ddd4__"